export abstract class NamedDiscoveryConfig<T extends NamedDiscoveryConfig<T>>  {
    readonly tag;
    private _enabled: boolean = false;

    constructor(tag: string) {
        this.tag = tag;
    }

    setEnabled(enabled: boolean): T {
        this._enabled = enabled;
        return this as unknown as T;
    }

    get enabled(): boolean {
        return this._enabled;
    }
}
